import { Marche } from '@/model/marche';
import Axios from 'axios';
import { ApiUtils } from './api-utils';

export class CoursMarcheApi {
  static getValeurMarches (): Promise<Marche[]> {
    return ApiUtils.responseParser(Axios.get('/web/v1/cours-marche'), [Marche]);
  }
}
